import { CatalogSectionContent } from 'src/types/contentBlocks';
import { CatalogBlock } from 'src/uikit/CatalogBlock';

const DEFAULT_TITLE = 'Доступные сервисы платформы';

export function CatalogSection(props: CatalogSectionContent['data']) {
  const { id, title = DEFAULT_TITLE, categories = [], products = [] } = props;

  const allSolutionsLength =
    products?.filter((product) => product.type === 'solutions').length ?? 0;
  const allProductsLength =
    products?.filter((product) => product.type === 'products').length ?? 0;

  return (
    <CatalogBlock
      id={id}
      title={title}
      categories={categories}
      products={products}
      allProductsLength={allProductsLength}
      allSolutionsLength={allSolutionsLength}
    />
  );
}
